// import rehypeLinkHeadings from 'rehype-autolink-headings'
// import rehypeSlug from 'rehype-slug'
import rehypeShiftHeading from 'rehype-shift-heading'
import rehypeStringify from 'rehype-stringify'
import remarkParse from 'remark-parse'
import remarkRehype from 'remark-rehype'
import { unified } from 'unified'

// TODO: Move to server utils
export async function markdownToHtml(markdown: string) {
	const { value: html } = await unified()
		.use(remarkParse)
		.use(remarkRehype)
		.use(rehypeShiftHeading, { shift: 1 })
		// TODO: Link to heading
		// TODO: https://unifiedjs.com/explore/package/rehype-slug/#security
		// .use(rehypeSlug)
		// .use(rehypeLinkHeadings, { behavior: 'wrap' })
		.use(rehypeStringify)
		.process(markdown)
	return html
}

export function transformImage(
	image: File,
	size: number = 400,
	type: string = 'image/jpeg',
	quality: number = 75,
) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.readAsDataURL(image)
		reader.onerror = (error) => reject(error)
		reader.onload = (event) => {
			const image = document.createElement('img')
			image.src = event.target?.result as string
			image.onerror = (error) => reject(error)
			image.onload = (event) => {
				const img = event.target as HTMLImageElement
				const canvas = document.createElement('canvas')
				const context = canvas.getContext('2d')
				canvas.width = size
				canvas.height = size

				let startX = 0
				let startY = 0
				let endX = img.width
				let endY = img.height

				const vertical = img.height > img.width
				if (vertical) {
					startY = (img.height - img.width) / 2
					endY = img.width
				} else {
					startX = (img.width - img.height) / 2
					endX = img.height
				}
				// console.log({ startX, startY, endX, endY })
				// TODO: Test with images smaller than 400px
				context?.drawImage(
					image,
					startX,
					startY,
					endX,
					endY,
					0,
					0,
					size,
					size,
				)
				const resized = context?.canvas.toDataURL(type, quality)
				resolve(resized)
			}
		}
	})
}

export function sortNodes(a: { category: string }, b: { category: string }) {
	const weights: { [category: string]: number } = {
		shapes: 1,
		behaviours: 2,
		utilities: 3,
		effects: 4,
		generators: 5,
	}
	if (weights[a.category] < weights[b.category]) {
		return -1
	}
	if (weights[a.category] > weights[b.category]) {
		return 1
	}
	return 0
}

export function sortCategories(a: string[], b: string[]) {
	const weights: { [category: string]: number } = {
		shapes: 1,
		behaviours: 2,
		utilities: 3,
		effects: 4,
		generators: 5,
	}
	if (weights[a[0]] < weights[b[0]]) {
		return -1
	}
	if (weights[a[0]] > weights[b[0]]) {
		return 1
	}
	return 0
}

export function groupBy(arr: [], cb: (item: any) => {}) {
	if (!Array.isArray(arr)) {
		throw new Error('expected an array for first argument')
	}

	if (typeof cb !== 'function') {
		throw new Error('expected a function for second argument')
	}

	var result = {}
	for (var i = 0; i < arr.length; i++) {
		var item = arr[i]
		var bucketCategory = cb(item)
		var bucket = result[bucketCategory]

		if (!Array.isArray(bucket)) {
			result[bucketCategory] = [item]
		} else {
			result[bucketCategory].push(item)
		}
	}

	return result
}
